
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";

const FooterNewsletter = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast({
        title: "Error",
        description: "Please enter your email address",
        variant: "destructive",
      });
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          access_key: "f73833ab-235f-473d-b803-999eb6905e43",
          name,
          email,
          subject: "New Footer Newsletter Subscription from Armpits.com",
          from_name: "Armpits.com Footer Newsletter",
          to_email: "info@fijidigital.com",
        }),
      });
      
      const data = await response.json();
      
      if (data.success) {
        setName("");
        setEmail("");
        toast({
          title: "Success!",
          description: "Thank you for subscribing to our newsletter!",
          variant: "default",
        });
      } else {
        throw new Error("Something went wrong");
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "Something went wrong. Please try again later.",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      <h4 className="text-lg font-medium mb-4">Newsletter</h4>
      <p className="text-muted-foreground mb-4">
        Subscribe to our newsletter for the latest updates.
      </p>
      <form onSubmit={handleSubmit} className="space-y-2">
        <div className="relative">
          <Input
            type="text"
            placeholder="Your name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="mb-2"
          />
        </div>
        <div className="relative">
          <Input
            type="email"
            placeholder="Your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <Button 
          type="submit" 
          className="w-full"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Subscribing..." : "Subscribe"}
        </Button>
      </form>
    </div>
  );
};

export default FooterNewsletter;
